<template>
  <div class="table-responsive">
    <table class="table mb-0">
      <thead class="table-light">
        <tr>
          <th>Α/Α</th>
          <th>Τύπος</th>
          <th>Δικαιούμενες</th>
          <th>Ληφθείσες</th>
          <th>Υπόλοιπο</th>

        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(stat,index) in statsHrms"
          :key="index"
        >
          <th scope="row">{{index + 1 }}</th>

          <td
            @click.prevent="showChart(stat.lty_id)"
            class="td-clicked"
          >{{ stat.leave_type }}</td>
          <td>{{ stat.entitled_days}}</td>
          <td>{{ stat.taken_days}}</td>
          <td>{{ stat.entitled_days -  stat.taken_days }}</td>
        </tr>
      </tbody>
    </table>

  </div>
</template>

<script>
export default {
  props: ["statsHrms"],
  data() {
    return {};
  },
  methods: {
    showChart(leaveTypeId) {
      this.$emit("showChartByLeaveType", leaveTypeId);
    },
  },
};
</script>


<style>
.td-clicked:hover {
  cursor: pointer;
}
</style>